import { Backdrop, CircularProgress, Typography } from "@mui/material";
import { FC } from "react";

import { Log, MuiPaletteType } from "@ryde/shared";

interface ILoaderMuiLanding {
  loading: boolean;
  text?: string;
  color?: MuiPaletteType;
  disableShrink?: boolean;
}

export const LoaderMuiLanding: FC<ILoaderMuiLanding> = ({
  loading,
  text,
  color = "primary",
  disableShrink,
}) => {
  const handleClose = (): void => {
    Log.debug(`backdrop click`);
  };

  return (
    loading && (
      <Backdrop
        sx={{
          backgroundColor: "rgba(139, 139, 139, 0.9)",
          zIndex: theme => theme.zIndex.modal + 1,
        }}
        open={loading}
        onClick={handleClose}
      >
        <CircularProgress
          color={color}
          size={80}
          thickness={4}
          disableShrink={disableShrink}
        />
        <Typography
          variant="h6"
          color="primary"
          sx={{ mx: 2, display: "block" }}
        >
          {text}
        </Typography>
      </Backdrop>
    )
  );
};
